import React from 'react';
import { Box, Typography, Link as MuiLink } from '@mui/material';
import { blockPadding, sectionContainerSx } from '../theme/standards';
import { PERIPLO_URL, PERIPLO_BRAND } from '../constants/periplo';
import periploIcon from '../periplo_icon.png';

export const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        display: { xs: 'none', sm: 'block' },
        bgcolor: 'background.paper',
        mt: 'auto',
        borderTop: '1px solid',
        borderColor: 'divider',
        position: 'relative',
        zIndex: 10,
      }}
    >
      <Box
        sx={{
          ...sectionContainerSx,
          ...blockPadding,
          flexDirection: { xs: 'column', sm: 'row' },
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 2,
        }}
      >
          <Typography variant="body2" color="text.secondary">
            © 2025 TripGen AI. Built by{' '}
            <MuiLink 
              href="https://www.linkedin.com/in/nikita-baklazhenko/" 
              target="_blank" 
              rel="noopener noreferrer"
              sx={{ 
                color: 'text.secondary', 
                textDecoration: 'underline',
                fontWeight: 500,
                '&:hover': { color: 'primary.main' } 
              }}
            >
              Nikita Baklazhenko
            </MuiLink>
          </Typography>

          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <MuiLink
              href={PERIPLO_URL}
              target="_blank"
              rel="noopener noreferrer"
              variant="body2"
              sx={{
                color: 'text.secondary',
                textDecoration: 'none',
                fontWeight: 500,
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.75,
                '&:hover': { color: PERIPLO_BRAND.main }
              }}
            >
              <Box
                component="img"
                src={periploIcon}
                alt=""
                sx={{ width: 16, height: 16, borderRadius: '24%' }}
              />
              Try Periplo
            </MuiLink>
            <MuiLink
              href="/blog"
              variant="body2"
              sx={{
                color: 'text.secondary',
                textDecoration: 'none',
                fontWeight: 500,
                '&:hover': { color: 'primary.main' }
              }}
            >
              Blog
            </MuiLink>
            <MuiLink
              href="/destinations"
              variant="body2"
              sx={{
                color: 'text.secondary',
                textDecoration: 'none',
                fontWeight: 500,
                '&:hover': { color: 'primary.main' }
              }}
            >
              Destinations
            </MuiLink>
            <MuiLink
              href="mailto:nikita.baklazhenko@bse.eu"
              variant="body2"
              sx={{ 
                color: 'text.secondary', 
                textDecoration: 'none', 
                fontWeight: 500, 
                '&:hover': { color: 'primary.main' } 
              }}
            >
              Email
            </MuiLink>
            <MuiLink 
              href="https://www.linkedin.com/in/nikita-baklazhenko/" 
              target="_blank" 
              rel="noopener noreferrer"
              variant="body2"
              sx={{ 
                color: 'text.secondary', 
                textDecoration: 'none', 
                fontWeight: 500, 
                '&:hover': { color: 'primary.main' } 
              }}
            >
              LinkedIn
            </MuiLink>
          </Box>
      </Box>
    </Box>
  );
}; 
